"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNumberCellFormatter = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var numberCellClass = data_catalog_shared_1.cssClass('numberCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle, {
    textAlign: 'right',
});
var disabledNumberCellClass = data_catalog_shared_1.cssClass('numberCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle, data_catalog_shared_1.cellDisabledStyle, {
    textAlign: 'right',
});
function NumberCellFormatter(props) {
    var formattedNumber = props.number != null ? Localize_1.Formatters.formatCount(props.number) : undefined;
    return (React.createElement("div", { className: props.disabled ? disabledNumberCellClass : numberCellClass, title: formattedNumber }, formattedNumber));
}
function createNumberCellFormatter(getNumberFromRowData, getDisabledFromRowData) {
    return function (props) { return (React.createElement(NumberCellFormatter, { disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, number: getNumberFromRowData(props.row.data) })); };
}
exports.createNumberCellFormatter = createNumberCellFormatter;
//# sourceMappingURL=NumberCellFormatter.js.map